import React, { type FC } from "react";
import { CookiesProvider } from "react-cookie";
import AICHeader from "src/components/AICLayout/AICHeader/AICHeader";
import PermissionsFetcher from "src/components/AICLayout/AICHeader/Permissions/PermissionsFetcher";
import { AlertContextProvider } from "src/components/Alert/AlertContext";
import AlertListBox from "src/components/Alert/AlertListBox";
import { AuthorizationErrorsContextProvider } from "src/components/Contexts/AuthorizationErrorsContext";
import { CountrySelectionContextProvider } from "src/components/Contexts/CountrySelectionContext";
import { LanguageContextProvider } from "src/components/Contexts/LanguageContext";
import { NestContextProvider } from "src/components/Contexts/NestContext";
import { PermissionsContextProvider } from "src/components/Contexts/PermissionsContext";

const AICLayout: FC<AICLayoutProps> = ({
  disableCountryChange,
  fixedCountry,
  disableUrlSearchParamsUpdate,
  alertClassName,
  isNest,
  children,
}) => {
  return (
    <CookiesProvider>
      <AuthorizationErrorsContextProvider>
        <PermissionsContextProvider>
          <CountrySelectionContextProvider>
            <LanguageContextProvider>
              <NestContextProvider>
                <AlertContextProvider>
                  <PermissionsFetcher />
                  <AICHeader
                    fixedCountry={fixedCountry}
                    disableCountryChange={disableCountryChange}
                    disableUrlSearchParamsUpdate={disableUrlSearchParamsUpdate}
                    isNest={isNest}
                  />
                  {children}
                  <AlertListBox className={alertClassName} />
                </AlertContextProvider>
              </NestContextProvider>
            </LanguageContextProvider>
          </CountrySelectionContextProvider>
        </PermissionsContextProvider>
      </AuthorizationErrorsContextProvider>
    </CookiesProvider>
  );
};

export interface AICLayoutProps {
  disableCountryChange?: boolean;
  fixedCountry?: string;
  disableUrlSearchParamsUpdate?: boolean;
  alertClassName?: string;
  isNest?: boolean;
}

export default AICLayout;
